<template>
    <div class="nav">
        <ul class="clearfix">
          <template v-for="(nav,key) in navList">
            <router-link :to="{path:nav.path,query:nav.query}" tag="li" :class="{'bgColor':Index==key}">{{nav.name}}</router-link>
          </template>
        </ul>
    </div>
</template>

<script>
    export default {
        name: '',
        props:['Index','cityCode'],
        data () {
            console.log(this.Index);
            return {
                navList:[
                  {name:'首页',path:'/',query:{cityCode:this.cityCode}},
                  {name:'车型展示',path:'/Second',query:{cityCode:this.cityCode}},
                  {name:'成功案列',path:'/SuccessCase',query:{cityCode:this.cityCode}},
                  {name:'服务范围',path:'/ScopeService',query:{cityCode:this.cityCode}},
                  {name:'租车须知',path:'/FourPage',query:{cityCode:this.cityCode}},
                  {name:'新闻中心',path:'/NewsCenter',query:{cityCode:this.cityCode}},
                  {name:'联系我们',path:'/NavContactUs',query:{cityCode:this.cityCode}}
                ],
                number:1
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clear {overflow: hidden;}
    .clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}

    .nav{height: 80px;line-height: 80px;background: #2C3E50;border-top: 4px solid #1dd2af;overflow-x: auto}
    .nav ul{height: 100%;overflow-x: auto;overflow-y: hidden;width: 1316px;overflow: hidden}
    .nav ul li a{font-size:14px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(255,255,255,1);}
    .nav ul li{width: 188px;;text-align: center;font-size:28px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(255,255,255,1);float: left;height: 100%}
    .bgColor{background: #1dd2af}
</style>



// WEBPACK FOOTER //
// src/components/Nav/Nav.vue